const addCustomListenerForCartStatusChange = () => {
  function myObserverFunction(status) {
    if (status === 'fetching') {
      window.isCartFetching = true;
    } else if (window.isCartFetching) {
      window.isCartFetching = false;

      if (wasCodeAddedFromInput) {
        wasCodeAddedFromInput = false;
        setTimeout(scrollToCartBottomPosition, 1000);
      }
    }
  }

  let _status = Rebuy.Cart.status;

  Object.defineProperty(Rebuy.Cart, 'status', {
    get() {
      return _status;
    },
    set(newValue) {
      _status = newValue;
      myObserverFunction(newValue);
    },
    configurable: true,
    enumerable: true,
  });
};

document.addEventListener('rebuy:cart.ready', addCustomListenerForCartStatusChange);

const setCartElementsDisabledDependOnCartFetchingStatus = (elements, isDisabled) => {
  if (isDisabled) {
    elements.forEach((el) => {
      el.setAttribute('disabled', 'disabled');
    });
  } else {
    elements.forEach((el) => el.removeAttribute('disabled'));
  }
};

const blockCartActions = () => {
  const onChangeItems = document.querySelectorAll(`[data-cart-blocking="onchange"]`);
  const onClickItems = document.querySelectorAll(`[data-cart-blocking="onclick"]`);

  const elements = [...onChangeItems, ...onClickItems];

  onChangeItems.forEach((item) => {
    item.onchange = () => setCartElementsDisabledDependOnCartFetchingStatus(elements, true);
  });
  onClickItems.forEach((item) => {
    const prev = item.ondblclick;
    item.onclick = () => {
      setCartElementsDisabledDependOnCartFetchingStatus(elements, true);
      if (prev && typeof prev === 'function') prev();
    };
  });
};
const blockCartActionsTimeout = () => setTimeout(blockCartActions, 350);

let _isCartFetching = window.isCartFetching;
Object.defineProperty(window, 'isCartFetching', {
  get() {
    return _isCartFetching;
  },
  set(value) {
    _isCartFetching = value;
    const elements = document.querySelectorAll(`[data-cart-blocking]`);
    setCartElementsDisabledDependOnCartFetchingStatus(elements, value);
  },
});

document.addEventListener('rebuy:cart.unblockElements', () => {
  const elements = document.querySelectorAll(`[data-cart-blocking]`);
  setCartElementsDisabledDependOnCartFetchingStatus(elements, false);
});

document.addEventListener('rebuy:smartcart.ready', blockCartActionsTimeout);
document.addEventListener('rebuy:cart.change', blockCartActionsTimeout);
document.addEventListener('rebuy:cart.enriched', blockCartActionsTimeout);
